const logglyConfig = require('../loggly.json');

const env = process.env.NODE_ENV;
const basename = process.env.base;
const apiPort = 44351;

const urlParts = window.location.hostname.split('.');
const baseDomainSiteUrl = env !== 'development' && urlParts != null && urlParts.length > 2
  ? `${ window.location.protocol }//${ urlParts.shift() }-api.${ urlParts.join('.') }`
  : 'https://localhost';

const basePathSiteUrl = env !== 'development' ? `${ window.location.protocol }//${ window.location.hostname }` : 'https://localhost';

const getBaseApiUrl = (routing) => {
  if (env === 'development') {
    return `https://localhost:${ apiPort }${ basename }api`;
  }
  let baseSiteUrl = null;
  switch (routing) {
    case 'path':
      baseSiteUrl = basePathSiteUrl;
      break;
    default:
      baseSiteUrl = baseDomainSiteUrl;
  }
  return `${ baseSiteUrl }${ basename }api`;
};

const EnvConfig = {
  env,
  baseApiUrl: getBaseApiUrl,
  cookieConsentName: 'tt_cc',
  eulaCookieName: 'tt_e',
  loginSessionCookieName: 'tt_ls',
  autentaLinkResendName: 'tt_ar',
  localeCookieName: 'tt_l',
  apiEndpoints: {
    authentaLink: '/auth/authentaLink',
    login: '/auth/login',
    logout: '/auth/logout',
    token: '/auth/token',
    forms: '/forms',
    language: '/language',
    config: '/config',
    auth: '/auth',
    validatePin: '/auth/validatePin',
    supportingDocuments: '/supportingdocuments',
    questionnaire: '/questionnaire',
    formGroups: '/formGroups',
  },
  showAnyError: env !== 'production',
  loggly: {
    enabled: env !== 'development',
    key: logglyConfig.key,
    src: logglyConfig.src
  }
};

export default EnvConfig;
